import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["MarkedMeasurementLog"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      postMarkedMeasurementLogGet: build.query<
        PostMarkedMeasurementLogGetApiResponse,
        PostMarkedMeasurementLogGetApiArg
      >({
        query: (queryArg) => ({
          url: `/MarkedMeasurementLog/Get`,
          method: "POST",
          body: queryArg,
        }),
        providesTags: ["MarkedMeasurementLog"],
      }),
      putMarkedMeasurementLogById: build.mutation<
        PutMarkedMeasurementLogByIdApiResponse,
        PutMarkedMeasurementLogByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/MarkedMeasurementLog/${queryArg.id}`,
          method: "PUT",
          body: queryArg.markedMeasurementLogDto,
        }),
        invalidatesTags: ["MarkedMeasurementLog"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as markedMeasurementLogApi };
export type PostMarkedMeasurementLogGetApiResponse =
  /** status 200 OK */ MarkedMeasurementLogDto[];
export type PostMarkedMeasurementLogGetApiArg = MarkedMeasurementLogRequestDto;
export type PutMarkedMeasurementLogByIdApiResponse = /** status 200 OK */ void;
export type PutMarkedMeasurementLogByIdApiArg = {
  id: number;
  markedMeasurementLogDto: MarkedMeasurementLogDto;
};
export type MarkedMeasurementLogStatus = "open" | "used" | "discarded";
export type MarkedMeasurementLogDto = {
  id: number;
  rule?: string | null;
  measuringPoint?: string | null;
  start?: number;
  end?: number;
  status: MarkedMeasurementLogStatus;
  dataFieldId?: number;
  dataFieldName?: string | null;
  comment?: string | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type MarkedMeasurementLogRequestDto = {
  start?: string | null;
  end?: string | null;
  status?: MarkedMeasurementLogStatus[] | null;
  measuringPoints?: string[] | null;
};
export const {
  usePostMarkedMeasurementLogGetQuery,
  useLazyPostMarkedMeasurementLogGetQuery,
  usePutMarkedMeasurementLogByIdMutation,
} = injectedRtkApi;
